import { Fragment } from "react";
import {
	Box,
	Divider,
	Typography,
	Container,
	IconButton,
	Tooltip,
} from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import ShoppingBagOutlinedIcon from "@mui/icons-material/ShoppingBagOutlined";
import ShoppingBagIcon from "@mui/icons-material/ShoppingBag";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/Auth/AuthContext";
import "./PayMethods.css";

function PayMethods({ productsInCart, banks }) {
	const { userData } = useAuth();
	const navigate = useNavigate();

	return (
		<Fragment>
			<Container>
				<Box display="flex" alignItems="center" minHeight="56px">
					<Box>
						<Tooltip title="Volver">
							<IconButton
								size="large"
								aria-label="volver"
								aria-controls="volver-carrito"
								aria-haspopup="false"
								color="inherit"
								onClick={() => navigate(-1)}
							>
								<ArrowBackIosIcon />
							</IconButton>
						</Tooltip>
					</Box>
					<Typography
						variant="h5"
						display="flex"
						justifyContent="center"
						alignItems="center"
						flexGrow={1}
					>
						Formas de pago
					</Typography>
					<Box>
						<Tooltip title="Carrito">
							<Link to="/cart">
								<IconButton
									size="large"
									aria-label="carrito"
									aria-controls="logo-carrito"
									aria-haspopup="false"
									color="inherit"
								>
									{productsInCart > 0 ? (
										<ShoppingBagIcon color="secondary" />
									) : (
										<ShoppingBagOutlinedIcon color="secondary" />
									)}
								</IconButton>
							</Link>
						</Tooltip>
					</Box>
				</Box>
			</Container>
			<Divider />
			<Container>
				<Box className="boxAddressShippingContainer" my={1} pt={2}>
					<Typography className="titleFirstRow" sx={{ fontWeight: "600" }}>
						Método de pago
					</Typography>
					{/* <Typography onClick={handleShow}>Editar</Typography> */}
				</Box>
				<Divider />
				<Container
					sx={{
						marginTop: "1rem",
						marginBottom: "1rem",
						backgroundColor: "#FFF",
					}}
				>
					<Box
						sx={{
							display: "flex",
							justifyContent: "space-between",
							marginBottom: "4rem",
						}}
					>
						<Box sx={{ display: "flex" }}>
							<AccountBalanceWalletOutlinedIcon />
							<Typography className="payment_title_typography">
								{userData.clientPaymentMethod}
							</Typography>
						</Box>
						<Typography
							className="textDefault"
							sx={{
								fontWeight: "600",
								fontSize: "0.76rem",
								marginTop: "4px",
							}}
						>
							predeterminada
						</Typography>
					</Box>
					<Divider />
					<Container sx={{ marginBottom: "1rem", marginTop: "1rem" }}>
						<Typography>Titular: GRUPO MONACO SRL</Typography>
						<Typography>Cuit: 30-71606701-3</Typography>
					</Container>
					{banks?.map((bank) => (
						<Fragment key={bank.bankId}>
							<Divider />

							<Typography
								variant="subtitle1"
								sx={{
									fontSize: "1rem",
									fontWeight: "600",
									textTransform: "capitalize",
								}}
							>
								{bank.bankName}
							</Typography>
							<Container>
								<Typography sx={{ textTransform: "capitalize" }}>
									{bank.bankAccountType}
								</Typography>
								<Typography>N° de cuenta: {bank.bankAccountNumber}</Typography>
								<Typography>CBU: {bank.bankCBUNumber}</Typography>
								<Box sx={{ display: "flex", paddingBottom: "10px" }}>
									<Typography>Alias: </Typography>
									<Typography
										sx={{
											textTransform: "uppercase",
											paddingLeft: "5px",
										}}
									>
										{bank.bankAlias}
									</Typography>
								</Box>
							</Container>
						</Fragment>
					))}

					{/* <FormControl fullWidth>
						<RadioGroup
							aria-labelledby="Selección método de pago"
							defaultValue=""
							name="Método de pago"
							onChange={handleRadio}
						>
							<Box
								display="flex"
								justifyContent="space-between"
								alignItems="center"
							>
								<AccountBalanceWalletOutlinedIcon />
								<Typography className="payment_title_typography">
									Efectivo
								</Typography>
								<FormControlLabel
									value="efectivo"
									checked={paymentForm.paymentMethod === "efectivo"}
									control={
										<CheckoutRadio
											sx={{
												"&.Mui-checked": {
													color: "#292929",
												},
											}}
										/>
									}
									label={
										paymentForm.paymentMethod === "efectivo" ? (
											<Typography
												className="textDefault"
												sx={{
													fontWeight: "600",
													fontSize: "0.76rem",
													marginTop: "4px",
												}}
											>
												predeterminada
											</Typography>
										) : (
											""
										)
									}
									labelPlacement="start"
									sx={{
										flex: 1,
										display: "flex",
										justifyContent: "space-between",
										marginLeft: ".5rem",
									}}
								/>
							</Box>
							<Divider />
							<Box
								display="flex"
								justifyContent="space-between"
								alignItems="center"
								marginTop="20px"
							>
								<CreditCardOutlinedIcon />
								<Typography className="payment_title_typography">
									Transferencia
								</Typography>
								<FormControlLabel
									value="transferencia"
									control={
										<Box
											display="flex"
											alignItems="center"
											onClick={handleExpandClick}
										>
											<ExpandMore
												expand={expanded}
												aria-expanded={expanded}
												aria-label="detalle bancos"
											>
												<ExpandMoreIcon style={{ paddingRight: "1px" }} />
											</ExpandMore>
										</Box>
									}
									label=""
									labelPlacement="start"
									sx={{
										flex: 1,
										display: "flex",
										justifyContent: "space-between",
										marginLeft: ".5rem",
									}}
								/>
							</Box>
							<Collapse
								in={expanded}
								timeout="auto"
								unmountOnExit
								sx={{ width: "100%", marginTop: "0.5rem" }}
							>
								{banks?.map((bank) => (
									<Fragment key={bank.idTransferPayments}>
										<Box
											display="flex"
											justifyContent="space-between"
											alignItems="center"
										>
											<Typography
												className="bank_title_typography"
												style={{ fontWeight: "600" }}
											>
												{bank.bankName}
											</Typography>
											<FormControlLabel
												value={bank.bankName}
												checked={
													paymentForm.paymentMethod === `${bank.bankName}`
												}
												control={
													<CheckoutRadio
														sx={{
															"&.Mui-checked": {
																color: "#292929",
															},
														}}
													/>
												}
												label={
													paymentForm.paymentMethod === `${bank.bankName}` ? (
														<Typography
															className="textDefault"
															sx={{
																fontWeight: "600",
																fontSize: "0.76rem",
																marginTop: "4px",
															}}
														>
															predeterminada
														</Typography>
													) : (
														""
													)
												}
												labelPlacement="start"
												sx={{
													flex: 1,
													display: "flex",
													justifyContent: "space-between",
													marginLeft: ".5rem",
												}}
											/>
										</Box>
										<Typography sx={{ textTransform: "capitalize" }}>
											{bank.accountType}
										</Typography>
										<Typography>N° de cuenta: {bank.accountNumber}</Typography>
										<Typography>CBU: {bank.cbuNumber}</Typography>
										<Box sx={{ display: "flex", paddingBottom: "10px" }}>
											<Typography>Alias:</Typography>
											<pre> </pre>
											<Typography sx={{ textTransform: "uppercase" }}>
												{bank.accountAlias}
											</Typography>
										</Box>
										<Divider />
									</Fragment>
								))}
							</Collapse>
						</RadioGroup>
					</FormControl>
					<ThemeProvider theme={themeBtn}>
						<Box className="boxBtnContainer">
							<Button
								className="btnAddressShipping"
								variant="outlined"
								type="submit"
								sx={{
									fontSize: "1rem",
									textAlign: "center",
									textTransform: "capitalize",
									paddingLeft: 5,
									paddingRight: 5,
								}}
								// onClick={() => handleHidde(payMethod)}
							>
								guardar pago predeterminado
							</Button>
						</Box>
					</ThemeProvider> */}
				</Container>
			</Container>
		</Fragment>
	);
}

export default PayMethods;
